import { MouseEvent } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IMediaItem } from '../types/Interfaces';

export const searchFilterLogic = (props: any) => {
  const { searchInput, listOfData, keys, dropdownValue, dropdownKey } = props;
  const regex = /^[a-zA-Z0-9\s.\u0600-\u06FF-]+$/;
  if (!regex.test(searchInput)) {
    return [];
  }

  return listOfData?.filter((item: any) =>
    keys.some((key: any, index: number) => {
      const nestedKeys = key.split('.'); // Split nested key by dot
      let value = item;
      for (const nestedKey of nestedKeys) {
        value = value?.[nestedKey];
        if (value === undefined) {
          return false; // Stop iteration if nested key not found
        }
      }
      const result =
        value?.toString().toLowerCase().includes(searchInput.toLowerCase()) && (!dropdownValue || item?.[dropdownKey]?.some((category: any) => category?.id == dropdownValue));
      return result;
    })
  );
};

export const buildFormData = (formData: FormData, data: any, parentKey: string) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;

    formData.append(parentKey, value);
  }
};

export const handleSorting = (prop: any) => {
  const { setState, list, value, startTransition } = prop;
  const originalList = [...list];
  if (value !== 'none') {
    const sortedList = originalList.sort((a: any, b: any) => {
      if (value === 'is_active') return b[`${value}`] - a[`${value}`];
      return a[`${value}`] - b[`${value}`];
    });
    startTransition(() => {
      setState(sortedList);
    });
  }
};

//Table row selection
export const handleBulkSelection = (selectedItems: string[], setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>, id: string) => {
  if (selectedItems && selectedItems?.includes(id)) {
    setSelectedItems && setSelectedItems((prev) => prev?.filter((item) => item !== id));
  } else {
    setSelectedItems && setSelectedItems((prev) => [...prev, id]);
  }
};

export const scrollToError = (error: boolean, ref: React.RefObject<HTMLDivElement>, errorMsg?: string) => {
  if (error) {
    ref?.current?.scrollIntoView({ behavior: 'smooth' });
    toast.error(errorMsg || `Please fill all required fields`);
  }
};

export const getFilterQuery = (filters: { [key: string]: string | null }) => {
  const query: string[] = [];

  Object.keys(filters).forEach((key) => {
    if (filters[key]) {
      query.push(`${key}=${filters[key]}`);
    }
  });

  return query.join('&');
};
export const hasPermission = (permissions: string[]) => {
  const userPermissions = JSON.parse(localStorage.getItem('user_permissions') as string);
  const hasPermissions = permissions?.some((permission: string) => userPermissions?.includes(permission));
  return hasPermissions;
};

export const hasAllPermission = (permissions: string[]) => {
  const userPermissions = JSON.parse(localStorage.getItem('user_permissions') as string);
  const hasPermissions = permissions?.every((permission: string) => userPermissions?.includes(permission));
  return hasPermissions;
};

export function navigateRoute(e: MouseEvent<HTMLDivElement, any>, path: string, navigate: NavigateFunction) {
  const contentContainer = document.querySelector('.layout_content');
  contentContainer?.scrollTo({ top: 0, behavior: 'smooth' });
  e.stopPropagation();
  navigate(path);
}

export function getMedia(media: IMediaItem[] | undefined, collection_name: string): IMediaItem | undefined {
  if(!media) return undefined;
  return media.find((item) => item.collection_name === collection_name);
}

export function getMediaArray(media: IMediaItem[] | undefined, collection_name: string): IMediaItem[] {
  if(!media) return [];
  return media.filter((item) => item.collection_name === collection_name);
}

export function removeEmpty(data: any, except?: string[]) {
  if (data && typeof data === 'object') {
    Object.keys(data).forEach((key) => {
      if ((except && except.includes(key)) || key.includes('image')) return;
      if (data[key] && typeof data[key] === 'object') {
        removeEmpty(data[key], except);
      } if (!data[key] && data[key] !== 0 && data[key] !== false) {
        delete data[key];
      }
    });
  }
  return data;
}

export function createFileList(files: File[]): FileList {
  const dataTransfer = new DataTransfer();
  files.forEach(file => {
    dataTransfer.items.add(file);
  });
  return dataTransfer.files;
}

export function convertFilesToBase64(files: FileList) {
  return new Promise((resolve, reject) => {
    const filePromises = Array.from(files).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file as Blob);
      });
    });

    Promise.all(filePromises)
      .then((base64Array) => resolve(base64Array))
      .catch((error) => reject(error));
  });
};

export function orderData(data: any) {
  if (data) {
    return data.sort((a: any, b: any) => {
      return Number(a.order) < Number(b.order) ? -1 : 1
    })
  }
}
